import axios from 'axios';

export const getAllAbitAccount = async () => {
    const url = `/api/v1/user_profile/bms/abit_accounts`;
    const res = await axios.get(url);
    return res.data;
};

export const createAbitAccount = async (data) => {
    const url = `/api/v1/user_profile/bms/abit_accounts`;
    const res = await axios.post(url, data);
    return res.data;
};

export const updateAbitAccount = async (id, data) => {
    const url = `/api/v1/user_profile/bms/abit_accounts/${id}`;
    const res = await axios.patch(url, data);
    return res.data;
};

export const deleteAbitAccount = async (id) => {
    const url = `/api/v1/user_profile/bms/abit_accounts/${id}`;
    const res = await axios.delete(url);
    return res.data;
};